import React from "react";

const LeadPriorityBadge = ({ priority }) => {
  const getPriorityConfig = (priority) => {
    const p = String(priority || "").toLowerCase();
    switch (p) {
      case "low":
        return {
          bgColor: "bg-gray-100 dark:bg-gray-900/20",
          textColor: "text-gray-600 dark:text-gray-400",
          label: "Low",
        };
      case "medium":
        return {
          bgColor: "bg-orange-100 dark:bg-orange-900/20",
          textColor: "text-orange-600 dark:text-orange-400",
          label: "Medium",
        };
      case "high":
        return {
          bgColor: "bg-red-100 dark:bg-red-900/20",
          textColor: "text-red-600 dark:text-red-400",
          label: "High",
        };
      case "urgent":
        return {
          bgColor: "bg-red-600 dark:bg-red-500",
          textColor: "text-white",
          label: "Urgent",
          extra: "ring-2 ring-red-300 dark:ring-red-700 font-semibold",
        };
      default:
        return {
          bgColor: "bg-gray-100 dark:bg-gray-900/20",
          textColor: "text-gray-600 dark:text-gray-400",
          label: priority || "",
        };
    }
  };

  const config = getPriorityConfig(priority);

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs ${config.textColor} ${config.bgColor} ${config.extra || "font-medium"}`}>
      {config.label}
    </span>
  );
};

export default LeadPriorityBadge;